import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import "./Economic.css";
import moment from "moment";
import axios from "axios";
import { Chart, registerables } from "chart.js";
import NewsGrid from "../NewsCarousel/NewsCarousel";

Chart.register(...registerables);

function Economic() {
  const [gdpData, setGdpData] = useState([]);
  const [inflationData, setInflationData] = useState([]);
  const [unemploymentData, setUnemploymentData] = useState([]);
  const [mortgagedata, setMortgageData] = useState([]);
  const [ffdata, setFFData] = useState([]);
  const [cpiData, setCpiData] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.stockastix.com/economic/get_economic_data/")
      .then((response) => {
        console.log("Economic data fetched:", response.data);
        setGdpData(response.data.gdp_data);
        setInflationData(response.data.inflation_data);
        setUnemploymentData(response.data.unemployment_data);
        setMortgageData(response.data.mortgage_data);
        setFFData(response.data.fedfunds_data);
        setCpiData(response.data.cpi_data);
      })
      .catch((error) => {
        console.error("Error fetching GDP data:", error);
      });
  }, []);

  const colors = [
    {
      borderColor: "rgba(255, 99, 132, 1)",
      backgroundColor: "rgba(255, 99, 132, 0.1)",
    }, // Pink
    {
      borderColor: "rgba(54, 162, 235, 1)",
      backgroundColor: "rgba(54, 162, 235, 0.1)",
    }, // Light Blue
    {
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "rgba(75, 192, 192, 0.1)",
    }, // Cyan
    {
      borderColor: "rgba(255, 206, 86, 1)",
      backgroundColor: "rgba(255, 206, 86, 0.1)",
    }, // Yellow
    {
      borderColor: "rgba(153, 102, 255, 1)",
      backgroundColor: "rgba(153, 102, 255, 0.1)",
    }, // Purple
    {
      borderColor: "rgba(255, 159, 64, 1)",
      backgroundColor: "rgba(255, 159, 64, 0.1)",
    }, // Orange
    {
      borderColor: "rgba(0, 255, 127, 1)",
      backgroundColor: "rgba(0, 255, 127, 0.1)",
    }, // Spring Green
  ];

  let colorIndex = 0;

  const createChartData = (data, label, datee) => {
    const color = colors[colorIndex % colors.length];
    colorIndex += 1;

    return {
      labels: datee
        ? data.map((item) => moment(item.date).format("DD MMM'YY"))
        : data.map((item) => moment(item.date).format("MMM'YY")),
      datasets: [
        {
          label,
          data: data.map((item) => item.value),
          fill: true,
          borderColor: color.borderColor,
          backgroundColor: color.backgroundColor,
          borderWidth: 2,
          pointRadius: 0,
        },
      ],
    };
  };

  const options = {
    responsive: true,
    interaction: { mode: "index", intersect: false },
    scales: {
      x: {
        title: { display: false },
        ticks: {
          color: "#ffffff",
          maxTicksLimit: 5,
          font: {
            size: 10,
          },
        },
      },
      y: {
        title: { display: false },
        beginAtZero: false,
        ticks: {
          color: "#ffffff",
          maxTicksLimit: 5,
          callback: function (value) {
            if (value >= 1000000) return (value / 1000000).toFixed(1) + "M";
            if (value >= 1000) return (value / 1000).toFixed(1) + "k";
            return value;
          },
          font: {
            size: 10,
          },
        },
        grid: { color: "#444444" },
      },
    },
    plugins: {
      legend: {
    display: true,
    position: "top",
    align: "end",
    labels: {
      color: "#ffffff",
      font: {
        size: 12, // Smaller text
      },
      usePointStyle: true,     // Use shape instead of default box
      pointStyle: "line",    // Circle shape
      padding: 5,             // Optional: spacing between items
    },
  },
      customValueDisplay: { display: true },
    },
  };

  const latestValuePlugin = {
    id: "latestValuePlugin",
    afterDraw: (chart) => {
      const ctx = chart.ctx;
      const datasets = chart.data.datasets;

      if (datasets.length > 0) {
        const latestData = datasets[0].data[datasets[0].data.length - 1];

        ctx.save();
        ctx.font = "bold 12px Arial";
        ctx.fillStyle = "#ffffff";
        ctx.textAlign = "left";
        ctx.fillText(
          `Latest value:`,
          chart.chartArea.left,
          chart.chartArea.top - 15
        );
        const latestValueX =
          ctx.measureText(`Latest value:`).width + chart.chartArea.left + 5;
        ctx.font = "12px Arial";
        ctx.fillText(`${latestData}`, latestValueX, chart.chartArea.top - 15);
        ctx.restore();
      }
    },
  };

  return (
    <div className="economics-container">
      <div className="headingED">
        <i>Economic Data</i>
      </div>
      <div className="graphs_row">
        <div className="graph_data">
          <h6>GDP</h6>
          <Line
            data={createChartData(gdpData, "GDP")}
            options={options}
            plugins={[latestValuePlugin]}
          />
        </div>
        <div className="graph_data">
          <h6>Inflation</h6>
          <Line
            data={createChartData(inflationData, "Inflation")}
            options={options}
            plugins={[latestValuePlugin]}
          />
        </div>
        <div className="graph_data">
          <h6>Producer Price Index</h6>
          <Line
            data={createChartData(cpiData, "Consumer Price Index")}
            options={options}
            plugins={[latestValuePlugin]}
          />
        </div>
      </div>
      <div className="graphs_row">
        <div className="graph_data">
          <h6>Unemployment Rate</h6>
          <Line
            data={createChartData(unemploymentData, "Unemployment")}
            options={options}
            plugins={[latestValuePlugin]}
          />
        </div>
        <div className="graph_data">
          <h6>Mortgage</h6>
          <Line
            data={createChartData(mortgagedata, "Mortgage", true)}
            options={options}
            plugins={[latestValuePlugin]}
          />
        </div>
        <div className="graph_data">
          <h6>Federal Funds</h6>
          <Line
            data={createChartData(ffdata, "Federal Funds")}
            options={options}
            plugins={[latestValuePlugin]}
          />
        </div>
      </div>
      <div className="news-section">
        <NewsGrid />
      </div>
    </div>
  );
}

export default Economic;
